/* Common Imports */

import React from "react";
import PropertyCard from "./PropertyCardDashboardEditorView/PropertyCardDashboardEditorView";

/* Component Imports */
import { ObjectId } from "bson";

import StateInterface from "../../../redux-magic/state-interface";
import PropertyLoadingCardDashboardEditorView from "../skeletonLoadingCard/PropertyLoadingCardDashboardEditorView";

/* Styled Components */

const PropertyCardGridView = ({
	PropertyId,
	dispatch,
	session,
	profile_context,
	isEditor,
	source,
	search_log_id,
	boost,
	show_only_listing_details,
	broadcastData,
	business_profile_id,
	broadcasted_property_id,
	broadcastFeatureDiscoveryTracker,
	ai_boosts,
}: {
	PropertyId: string | ObjectId;
	dispatch: any;
	session: StateInterface["redux_session"];
	profile_context: any;
	isEditor?: boolean | undefined;
	source?: string;
	search_log_id?: string | ObjectId;
	boost?: StateInterface["boost"];
	show_only_listing_details?: boolean;
	broadcastData?: StateInterface["broadcast_data"];
	business_profile_id?: string | ObjectId;
	broadcasted_property_id?: string | ObjectId;
	broadcastFeatureDiscoveryTracker?: StateInterface["feature_discovery_tracker"]["broadcast"];
	ai_boosts?: StateInterface["ai_boosts"];
}) => {
	const [propertyData, setPropertyData] = React.useState<any>({});

	const [propertyStats, setPropertyStats] = React.useState<any>({});

	const [propertyDataloading, setPropertyDataLoading] = React.useState(true);

	const [statsLoading, setStatsLoading] = React.useState(true);

	const [boostPropertySlug, setBoostPropertySlug] = React.useState<string>("");

	const boost_active: boolean = boost?.active || false;

	const boost_property_slug = boost?.property_id || null;

	React.useEffect(() => {
		if (PropertyId) {
			/* Fetching property data */

			fetch(`${process.env.PRODUCTION_API_URL}properties/cards/${PropertyId}?resize=""`, {
				method: "POST",
				headers: {
					"Content-Type": "text/plain",
				},
			})
				.then((res) => res.json())
				.then((data) => {
					setPropertyData(data.property_data);
					setPropertyDataLoading(false);
				});

			/* Fetching property stats */

			if (!show_only_listing_details) {
				fetch(`${process.env.PRODUCTION_API_URL}properties/cards/property-stats`, {
					method: "POST",
					headers: {
						"Content-Type": "text/plain",
					},
					body: JSON.stringify({
						_id: PropertyId,
					}),
				})
					.then((res) => res.json())
					.then((data) => {
						setPropertyStats(data.payload);
						setStatsLoading(false);
					});
			}
		}

		/* eslint-disable-next-line react-hooks/exhaustive-deps*/
	}, [PropertyId]);

	React.useEffect(() => {
		if (PropertyId === broadcasted_property_id) {
			/* Fetching property data */

			fetch(`${process.env.PRODUCTION_API_URL}properties/cards/${PropertyId}?resize=""`, {
				method: "POST",
				headers: {
					"Content-Type": "text/plain",
				},
			})
				.then((res) => res.json())
				.then((data) => {
					setPropertyData(data.property_data);
					setPropertyDataLoading(false);
				});

			/* Fetching property stats */

			if (!show_only_listing_details) {
				fetch(`${process.env.PRODUCTION_API_URL}properties/cards/property-stats`, {
					method: "POST",
					headers: {
						"Content-Type": "text/plain",
					},
					body: JSON.stringify({
						_id: PropertyId,
					}),
				})
					.then((res) => res.json())
					.then((data) => {
						setPropertyStats(data.payload);
						setStatsLoading(false);
					});
			}
		}

		/* eslint-disable-next-line react-hooks/exhaustive-deps*/
	}, [broadcasted_property_id]);

	React.useEffect(() => {
		if (boost_property_slug === propertyData.slug) {
			setBoostPropertySlug(boost_property_slug as string);
		}
		/* eslint-disable-next-line react-hooks/exhaustive-deps*/
	}, [boost_property_slug]);

	React.useEffect(() => {
		if (boostPropertySlug === propertyData.slug) {
			/* Fetching property data */

			fetch(`${process.env.PRODUCTION_API_URL}properties/cards/${PropertyId}`, {
				method: "POST",
				headers: {
					"Content-Type": "text/plain",
				},
			})
				.then((res) => res.json())
				.then((data) => {
					setPropertyData(data.property_data);
					setPropertyDataLoading(false);
				});

			/* Fetching property stats */

			if (!show_only_listing_details) {
				fetch(`${process.env.PRODUCTION_API_URL}properties/cards/property-stats`, {
					method: "POST",
					headers: {
						"Content-Type": "text/plain",
					},
					body: JSON.stringify({
						_id: PropertyId,
					}),
				})
					.then((res) => res.json())
					.then((data) => {
						setPropertyStats(data.payload);
						setStatsLoading(false);
					});
			}
		}
		/* eslint-disable-next-line react-hooks/exhaustive-deps*/
	}, [boost_active]);

	if (show_only_listing_details ? propertyDataloading : propertyDataloading || statsLoading) {
		return (
			<PropertyLoadingCardDashboardEditorView
				source={source}
				isEditor={isEditor}
				show_only_listing_details={show_only_listing_details !== undefined ? true : false}
			/>
		);
	}

	return (
		<React.Fragment>
			<PropertyCard
				propertyStatus={propertyData.status}
				business_profile_id={business_profile_id}
				broadcastData={broadcastData}
				_id={propertyData._id}
				profile_context={profile_context}
				session={session ? session : null}
				dispatch={dispatch}
				loading={show_only_listing_details ? propertyDataloading : propertyDataloading || statsLoading}
				slug={propertyData.slug}
				transaction_type={propertyData.transaction_type ? propertyData.transaction_type : ""}
				property_type={propertyData.property_type}
				title={propertyData.title}
				images={propertyData.images}
				location={propertyData.location ? propertyData.location.title : ""}
				developer={propertyData.builder ? propertyData.builder.name : ""}
				price={propertyData.price}
				bhk={propertyData.bhk}
				area={propertyData.area}
				no_of_seats={propertyData.no_of_seats}
				boosting={propertyData ? propertyData.boost_information : null}
				created_by={propertyData ? propertyData.created_by : null}
				source={source}
				published_status={propertyData.status}
				isEditor={isEditor}
				search_log_id={search_log_id as string}
				posted_on={propertyData.created_at}
				updated_on={propertyData.updated_at}
				leads_count={propertyStats ? propertyStats.leads_count : 0}
				views_count={propertyStats ? propertyStats.views_count : 0}
				shares_count={propertyStats ? propertyStats.shares_count : 0}
				saved_count={propertyStats ? propertyStats.saves_count : 0}
				is_recently_broadcasted={propertyStats ? propertyStats.is_recently_broadcasted : false}
				is_broadcasted_before={propertyStats ? propertyStats.is_broadcasted_before : false}
				time_left_to_broadcast_again={propertyStats ? propertyStats.time_left_to_broadcast_again : 0}
				show_only_listing_details={show_only_listing_details !== undefined ? show_only_listing_details : false}
				broadcastFeatureDiscoveryTracker={
					broadcastFeatureDiscoveryTracker as StateInterface["feature_discovery_tracker"]["broadcast"]
				}
				ai_boosts={ai_boosts as StateInterface["ai_boosts"]}
			/>
		</React.Fragment>
	);
};

export default PropertyCardGridView;
